module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot6-7d386414ea3cd66425800b3b57496d1f.png";